<template>
  <div class="form-group">
    <label :for="name" :class="hidelabel ? 'sr-only' :'' ">{{ label }}</label>
    <date-picker
      v-model="date"
      :config="options"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      autocomplete="off"
    ></date-picker>
    <span
      class="label label-danger form-error"
      v-if="errors[0] && name === 'departure'"
    >
      <strong>
        <span v-html="errors[0].value"></span>
      </strong>
    </span>
    <span
      class="label label-danger form-error"
      v-if="errors[0] && name === 'return'"
    >
      <strong>
        <span v-html="errors[0].value"></span>
      </strong>
    </span>
  </div>
</template>

<script>
import $ from "jquery";
// Import bootstrap datepicker
import datePicker from "vue-bootstrap-datetimepicker";

// Import date picker css, bootstrap css external in index.html
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  props: {
    errors: Array,
    name: String,
    id: String,
    label: String,
    placeholder: String,
    hidelabel: Boolean
  },
  components: {
    datePicker,
  },
  computed: {
    options() {
      let $minDate = this.name == "departure" ? new Date() : ($("#departure").val() ? $("#departure").val() : new Date());
      return {
        format: "YYYY-MM-DD",
        useCurrent: false,
        locale: this.$i18n.locale,
        minDate: $minDate
      };
    },
  },
  data() {
    return {
      date: "",
    };
  },
  mounted() {
    // eslint-disable-next-line
    // if (this.name == "departure") {
    //   // eslint-disable-next-line
    //   jQuery("#departure")
    //     .data("DateTimePicker")
    //     // eslint-disable-next-line
    //     .minDate(new Date());
    // }
    // eslint-disable-next-line
    // if (this.name == "return") {
    //   // eslint-disable-next-line
    //   jQuery("#return")
    //     .data("DateTimePicker")
    //     // eslint-disable-next-line
    //     .minDate(
    //       // eslint-disable-next-line
    //       jQuery("#departure").val() ? jQuery("#departure").val() : new Date()
    //     );
    // }
  },
  watch: {
    date: function (newdate) {
      this.$store.commit("setDate", { name: this.name, date: newdate });
      this.$store.dispatch("fetchOperatingMessages");
      // eslint-disable-next-line
      $("#departure").on("dp.change", function (e) {
        // eslint-disable-next-line
        if ($("#return").length) {
          // eslint-disable-next-line
          $("#return").data("DateTimePicker").minDate(e.date);
        }
      });
    },
  },
  methods: {
    // datepickerUpdate(date) {
    //   // eslint-disable-next-line
    //   if (this.name == "departure" && jQuery("#return").length) {
    //     // eslint-disable-next-line
    //     jQuery("#return").data("DateTimePicker").minDate(date);
    //   }
    // },
  },
};
</script>
<style lang="scss">
.mini-widget .datetime.form-group {
  position: relative;
  &::after {
    color: $brand-highlight;
    content: "\f073";
    position: absolute;
    top: 18px;
    right: 35px;
    display: inline-block;
    width: 10px;
    height: 10px;
    font-family: "FontAwesome";
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
  }

  .form-control {
    // background-color: #cecece;
    // color: $brand-primary;
    // border: 1px solid #ccc;
    box-shadow: none;
    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
    }
    &::placeholder {
      color: #1F2123;
      opacity: 1;
    }
  }
  &.col-sm-6.departure-wrapper {
    padding-right: 0px;
    &::after {
      right: 20px;
    }
    .form-control {
      padding-right: 0px;
    }
  }
}
</style>
